/**
 * Component for our Return details sidebar that
 * lets users view and edit the details of a Return.
 *
 * @component
 */

import {
  Button,
  Divider,
  Drawer,
  message,
  Tag,
  Row,
} from 'antd';
import axios from 'axios';
import React, { Component } from 'react';
import moment from 'moment';
import { SubscriptionContext } from '../../../../contexts/SubscriptionContext';
import '../../../../styles/App.css';
import ReturnDetails from './ReturnDetails';

class OrderDetails extends Component {
  static contextType = SubscriptionContext;

  constructor(props) {
    super(props);
    this.state = {
      //control loading state
      loading: true,
      buttonLoadingOrder: false,
      returnId: null,
      //control the return object
      orderNumber: null,
      // orderNumber: "1079",
      productsOfReturn: [],
      productData: {},
      productIds: {},
      orderObject: props.orderObject,
      //control return request
      returnRequest: {
        action: {},
      },
      selectedProduct: null,

      availableResolutionOptions: [
        'storeCredit',
        'exchangeItem',
        'storeWideExchange',
      ],
      returnMethod: null,
      currency: null,
      stateOfReturn: null,
      notesKey: undefined,
      isLoading: false,
      drawerVisible: false,
      drawerVisibleReturn: false,
      returnMethod: undefined,
      returnObject: null,
      labelService: null,
      shipDate: null,
      labelStatus: null,
      storeAddress: [],
      selectedStoreAddress: null,
      useGiftApiForStoreCredit: undefined,
      useDiscountCodeForStoreCredit: undefined,
      useStoreCredit: undefined,
      width: '50%',
      discountCodeStatusTracking: true,
      rejectionObservation: null,
      showObservationField: false,
    };
    this.resolutionOptions = {
      refundToOriginal: 'Refund',
      refundToExchange: 'Exchange',
      refundToCredit: 'Store credit',
      advancedExchange: 'Collection Exchange',
      multiple: 'Multiple',
      refundToCustom1: 'Custom 1',
      refundToCustom2: 'Custom 2',
      refundToCustom3: 'Custom 3',
      storeWideExchange: 'Store-Wide Exchange',
    };
  }

  componentDidMount = async () => {
    // await this.handleGetReturn();
  };

  getOrderReturns = async () => {
    try {
      const orderNumber = this.props.orderNumber;
      const response = await axios.get(`/api/returns/orders/${orderNumber}`);
      if (response.data?.returns) {
        this.setState({
          orderObject: {
            ...this.state.orderObject,
            returns: response.data.returns,
          },
        });
      }
    } catch (err) {
      return message.error('Error getting order returns. Please try again.', 5);
    }
  };

  statusColorMap = {
    Pending: 'orange',
    Approved: 'cyan',
    Rejected: 'magenta',
    'In Progress': 'blue',
  };

  hideReturnDetailDrawer = async () => {
    await this.getOrderReturns();
    this.setState({
      drawerVisibleReturn: false,
    });
  };
  render() {
    const orderObject = this.state.orderObject;
    const returns = orderObject?.returns.map((returnItem) => {
      const color = this.statusColorMap[returnItem?.returnStatus] || 'blue';
      return (
        <React.Fragment key={returnItem.returnNumber}>
          <div
            className="flex-row flex-between-xxs flex-middle-xxs"
            style={{ gap: 10 }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <div className="TextHeading TextHeading--xxs u-marginBottom--none">
                {returnItem.returnNumber}
              </div>
              <div style={{ padding: '10px 0' }}>
                <span>
                  <Tag color={color}>{returnItem?.returnStatus}</Tag>
                </span>
              </div>
              <div>
                <p>
                  Resolution: {this.resolutionOptions[returnItem.resolution]}
                </p>
              </div>
              <div>
                <p>
                  Request date:{' '}
                  <span>
                    {' '}
                    {moment(returnItem.createdAt).format('MMM DD, YYYY')}{' '}
                  </span>
                </p>
              </div>
            </div>
            <div className="flex-row flex-middle-xxs">
              <div>
                <Button
                  onClick={() => {
                    this.setState({
                      drawerVisibleReturn: true,
                      returnId: returnItem.id,
                    });
                  }}
                >
                  Manage
                </Button>
              </div>
            </div>
          </div>
          <Divider />
        </React.Fragment>
      );
    });
    return (
      <React.Fragment>
        <Drawer
          title={
            <div
              className="flex-row flex-between-xxs flex-middle-xxs flex-row--noMargin"
              style={{ gap: 10 }}
            >
              <div
                className="flex-row flex-middle-xxs flex-row--noMargin"
                style={{ flexDirection: 'column', alignItems: 'flex-start' }}
              >
                <div className="TextHeading TextHeading--xxs u-marginBottom--none">
                  #{orderObject?.orderNumber}
                </div>
                <div className="TextHeading TextHeading--xxs u-marginBottom--none">
                  {orderObject?.customerName}
                </div>
              </div>
              <div className="flex-row flex-row--noMargin">
                <Button onClick={() => this.props.hideDrawer()}>Cancel</Button>
              </div>
            </div>
          }
          placement="right"
          visible={this.props.drawerVisible}
          onClose={() => this.props.hideDrawer()}
          closable={false}
        >
          <div
            className="flex-row flex-row--noMargin"
            style={{ flexDirection: 'column', gap: 20 }}
          >
            <div className="flex-row">
              {/* Load info return */}
              <Row>
                <h2 className="TextHeading TextHeading--xxxs u-marginBottom--sm">
                  Order Information
                </h2>
              </Row>
            </div>
          </div>
          <div
            className="flex-row flex-row--noMargin"
            style={{ flexDirection: 'column', gap: 20 }}
          >
            <div className="flex-row">
              {/* Load info return */}
              <div
                className="flex-col-xxs-12"
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  paddingTop: '30px',
                }}
              >
                {returns}
              </div>
            </div>
          </div>
          {this.state.drawerVisibleReturn && (
            <ReturnDetails
              returnId={this.state.returnId}
              drawerVisible={this.state.drawerVisibleReturn}
              resolutionOptions={this.resolutionOptions}
              hideDrawer={this.hideReturnDetailDrawer}
              updateData={() => {}}
              setVisibilityOfResetSearchButton={() => {}}
            />
          )}
        </Drawer>
      </React.Fragment>
    );
  }
}

export default OrderDetails;
